import ResultatPatient from '@/views/analyse/registre_analyse/resultat-patient'

export default {
    name: 'resultat-patient-modal',
    components: {
        ResultatPatient
    },
    props: {
        results: Object,
        evolution_id: Number,
        view_result_loading: Boolean
    },

    data() {
        return {

        }
    },

    computed: {
        modalId() {
            if (this.evolution_id) {
                return `view-analysis-modal-${this.evolution_id}`;
            }

            return 'view-analysis-modal';
        },
    },

    mounted() {

    },

    methods: {
        printResultatPatient() {
            this.$emit('emitPrint', this.results)
        },
    }
}